import { DiagramDefinition } from "../types";

export const m004Definition: DiagramDefinition = {
  id: "M-004",
  title: "Solarch Middleware Architecture Chain",
  description:
    "Order of middleware execution in Solarch: Helmet Security Headers -> CORS -> Morgan Logger -> Body Parsers -> Rate Limiter -> Bearer Token Validator -> Target Route Handler.",
  viewBox: "0 0 750 280",
  nodes: [
    { id: "Client", kind: "client", label: "Client Request", position: [100, 70], size: [130, 44] },
    { id: "Helmet", kind: "service", label: "1. Helmet Security", subtext: "HTTP Headers", position: [270, 70], size: [155, 48] },
    { id: "CORS", kind: "service", label: "2. CORS Control", subtext: "Allowed Origins", position: [440, 70], size: [140, 44] },
    { id: "Logger", kind: "service", label: "3. Morgan Logger", subtext: "HTTP Request Log", position: [610, 70], size: [140, 44] },
    
    { id: "BodyParser", kind: "service", label: "4. Body Parsers", subtext: "JSON / Form Data", position: [610, 190], size: [140, 44] },
    { id: "RateLimit", kind: "service", label: "5. Rate Limiter", subtext: "IP Request Limits", position: [440, 190], size: [140, 44] },
    { id: "JWTAuth", kind: "service", label: "6. JWT Auth", subtext: "Bearer Token Check", position: [270, 190], size: [140, 44] },
    { id: "RouteHandler", kind: "service", label: "7. Route Handler", subtext: "Target Endpoint", position: [100, 190], size: [140, 44] },
  ],
  edges: [
    { id: "e1", source: "Client", target: "Helmet", sourcePort: "right", targetPort: "left", routing: "straight", animated: true },
    { id: "e2", source: "Helmet", target: "CORS", sourcePort: "right", targetPort: "left", routing: "straight" },
    { id: "e3", source: "CORS", target: "Logger", sourcePort: "right", targetPort: "left", routing: "straight" },
    { id: "e4", source: "Logger", target: "BodyParser", sourcePort: "bottom", targetPort: "top", routing: "straight" },
    { id: "e5", source: "BodyParser", target: "RateLimit", sourcePort: "left", targetPort: "right", routing: "straight" },
    { id: "e6", source: "RateLimit", target: "JWTAuth", sourcePort: "left", targetPort: "right", routing: "straight" },
    { id: "e7", source: "JWTAuth", target: "RouteHandler", sourcePort: "left", targetPort: "right", routing: "straight", animated: true },
  ],
};
